parseTokenYY